import React, { useState, useEffect } from "react";
import { useQuery } from 'react-query'
import { getResultsRSC } from "data/Querys"
import { isStartListStatus, isFinishedStatus } from "helpers/status";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Label from "components/general/Label"
import Loader from 'components/general/Loader'
import PageHeader from "components/common/PageHeader";
import { ProgressBarOWS as ProgressBar } from 'components/general/ProgressBar';
import LiveCheckBox from "components/general/LiveCheckbox";
import NotAvailable from "components/common/NotAvailable";
//Results
import OwsResults from 'components/sports/ows/views/OwsResults'
//Analysis
import OwsAnalysis from 'components/sports/ows/views/OwsAnalysis'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const OwsContext = () => {
    const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const [key, setKey] = useState(`1-${mirs_rsc}`);

    const getProgessBarConfiguration = () => {
        let config = {
            distance: {
                unit: ' Km',
                exceptions: [
                    { pos: 'S', label: 'HeaderStart' },
                ]
            },
            hideProgress: false,
            hidePassed: false,
        }

        return config;
    }
    const progressBarConfig = getProgessBarConfiguration();



    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    //DATA
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            //onError: (error) =>
            //    console.error(`Something went wrong: ${error.message}`),
        });

    if (isError) { return <NotAvailable /> }
    if (isLoading) { return <Loader /> }

    const resultStatus = data?.results?.status?.code;
    const isFinish = isFinishedStatus(resultStatus) ? true : false

    return (
        <>
            {data?.results ? (
                <>
                    <PageHeader data={data} />
                    <div className='mirs-page-container'>
                    {data?.progressBar && key === `2-${mirs_rsc}` && <ProgressBar id={`mirs-progressbar-${mirs_rsc}`} data={data.progressBar} config={progressBarConfig} dinamic={key === `2-${mirs_rsc}`} />}
                    {data?.progressBar && isFinish === false && key === `2-${mirs_rsc}` && <LiveCheckBox id={`mirs-livecheckbox-${mirs_rsc}`} />}

                    <Tabs
                        id="mirs-navsport"
                        className="mb-3 mirs-tab-result"
                        defaultActiveKey={`1-${mirs_rsc}`}
                        onSelect={(k) => setKey(k)}>

                        <Tab eventKey={`1-${mirs_rsc}`} title={<Label data=
                            {isStartListStatus(resultStatus)
                                ? "HeaderStartList"
                                : "HeaderResults"
                            }
                        />} >
                            <OwsResults data={data} caption={<Label data=
                                {isStartListStatus(resultStatus)
                                    ? "HeaderStartList"
                                    : "HeaderResults"
                                }
                            />} />
                        </Tab>

                        <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="HeaderRaceAnalysis" />} disabled=
                            {isStartListStatus(resultStatus)
                                ? true
                                : false
                            }
                        >
                            <OwsAnalysis data={data} />

                        </Tab>

                    </Tabs>

                    </div>

                </>
            ) : (
                <NotAvailable />
            )
            }
        </>
    );
};

export default OwsContext;
